/*jshint esversion: 6 */

import {
    tpl__header,
    tpl__dislike,
    tpl__toast,
    tpl__comment,
    tpl__fragment,
    tpl__xiangkan,
    tpl__xiangkanBtn,
    tpl__feedback,
    tpl__bottomTag,
    tpl__readmore,
} from './tpl';
import {
    Utils__parseQuery,
    Utils__getQueryString,
    Utils__checkErrorPage,
    Utils__isMiuiRomStable,
    Utils__noTopBar,
} from '../utils';
import { Common__domAddClass, Common__$, Common__domHide } from './common';
import { shareTextArr } from '../conf';

var  _fragment__queryString = Utils__getQueryString(),
    _fragment__clientHeight = (document.documentElement || document.body).clientHeight || 570, // 视口设置默认高度
    _fragment__state = Utils__parseQuery(_fragment__queryString);

export function Fragment__init() {
    var $fragment = document.createElement('template'),
        $miDetail = Common__$('#mi-detail'),
        tpl = [
            tpl__header,
            tpl__feedback,
            tpl__dislike,
            tpl__toast,
            tpl__comment,
            tpl__fragment,
        ],
        fragmentHtml = '';

    if (Utils__noTopBar()) { //顶部bar native
        tpl.shift();
        $miDetail.style.marginTop = 0;
    }

    _fragment__specialError($miDetail);

    tpl.forEach(function(item) {
        fragmentHtml += item();
    });

    $fragment.innerHTML = fragmentHtml;

    Common__domAddClass($miDetail, 'mi-detail__third-page');
    $miDetail.parentNode.appendChild($fragment.content);

    _fragment__setIframeUrl();
}

/* 添加阅读全文按钮 */
export function Fragment__insertReadMore() {
    if(_fragment__state.mitype && _fragment__state.mitype[0] == '0') {
        return;
    }

    const readMoreFragment = document.createElement('template');
    const $miDetail = Common__$('#mi-detail');
    const maxHeight = (window.location.href.indexOf('xkhot_word') > -1 ? 1.2 : 3) * _fragment__clientHeight;

    if ($miDetail.offsetHeight > maxHeight) {
        $miDetail.style.maxHeight = maxHeight + 'px'; // * 3
        Common__domAddClass($miDetail, 'mi-detail__hide-article');
        readMoreFragment.innerHTML = tpl__readmore();
        $miDetail.appendChild(readMoreFragment.content);
    }
}

/* 添加浮窗tag */
export function Fragment__insertTag(params) {
    var $tag = document.createElement('div'),
        $miDetail = Common__$('#mi-detail'),
        $tagBg,
        $tagContent;

    if (params.tagName && params.icon) {
        $tag.className = 'mi-detail__tag';
        $tag.innerHTML = '<div class="mi-detail__tag-bg"></div><div class="mi-detail__tag-container"><img class="mi-detail__tag-icon" src="' + params.icon + '"></img><div class="mi-detail__tag-text">' + params.tagName+ '</div></div>';
        $miDetail.appendChild($tag);
        $tagBg = Common__$('.mi-detail__tag-bg');
        $tagContent = Common__$('.mi-detail__tag-container');
        $tagBg.style.width = $tagContent.offsetWidth + 'px';
        $tagBg.style.height = $tagContent.offsetHeight + 'px';

        //发送到hot-detail中上报点击事件
        window.frames['mi-detail__iframe'].postMessage({ order: 'floatTagExpose', param: params }, '*');
    }
}

//针对zarke404页面的特殊处理
function _fragment__specialError($miDetail) {
    var $emptyBox = document.querySelector('#mi-detail > .empty-box'),
        miDetailHeight = $miDetail.getBoundingClientRect().height;

    //如果mi-detail高度为0说明此时，页面应该是404,给mi-detail设置一个最低高度
    if (miDetailHeight == 0) {
        $miDetail.style.minHeight = _fragment__clientHeight + 'px';

        if ($emptyBox) {
            $emptyBox.style.position = 'absolute';
        }
    }
}

function _fragment__setIframeUrl() {
    var query = _fragment__queryString || '',
        UA = navigator.userAgent || '',
        isAlpha = Utils__isMiuiRomStable() ? '#' : 'alpha/#',
        $iframe = Common__$('.mi-detail__iframe'),
        url = 'https://hot.browser.miui.com/detail/' + isAlpha + query;

    Utils__checkErrorPage(function(){
        $iframe.src = '';
        $iframe.height = 0;
        url = '';
    });

    $iframe.src = url;
}

export function Fragment__xiangkanInit() {
    var $miDetail = Common__$('#mi-detail'),
        $desc = Common__$('.xiangkan-detail__desc'),
        $fragment = document.createElement('template'),
        fragmentHtml = tpl__xiangkan(),
        url = 'https://feed.browser.miui.com/detail/#page=third&type=news&',
        query = Utils__getQueryString() || '',
        index;

    $fragment.innerHTML = fragmentHtml;

    if($miDetail) {
        $miDetail.parentNode.appendChild($fragment.content);

        if ($desc) {
            index = shareTextArr.indexOf($desc.innerHTML);
            url = url + 'textIndex=' + index + '&';
        }

        Common__$('.xiangkan-detail__iframe').src = url + query;
    }
}

export function Fragment__insertBottomTag(data) {
    var $bottomTag = document.createElement('div'),
        $miDetail = Common__$('#mi-detail');

    $bottomTag.innerHTML = tpl__bottomTag(data);
    $miDetail.appendChild($bottomTag);
}

export function Fragment__insertXiangaknBtn(data) {
    var $xiangkanBtn = document.createElement('div'),
        $miDetail = Common__$('.mi-detail__read-more'),
        $readMoreItem = Common__$('.mi-detail__read-more-item'),
        $readMoreItemIcon = Common__$('.mi-detail__read-more-icon-content');

    // 极少数偶现出现重复插入两个按钮
    if (Common__$('.mi-detail__read-more-xiangkan') || !$miDetail) {
        return;
    }
    // 偶尔获取不到$readMoreItem http://sentry.recharge.pay.xiaomi.com/sentry/feed-sdk-MIUIBrowser/issues/1766511/
    $readMoreItem && Common__domHide($readMoreItem);
    $readMoreItemIcon && Common__domHide($readMoreItemIcon);

    $xiangkanBtn.innerHTML = tpl__xiangkanBtn(data);
    $miDetail.appendChild($xiangkanBtn);
}

